import { render, staticRenderFns } from "./input-data-hora.vue?vue&type=template&id=460e0b52"
import script from "./input-data-hora.vue?vue&type=script&lang=js"
export * from "./input-data-hora.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports